// extracted by mini-css-extract-plugin
export default {"authorityIcon":"authorityIcon---q5T_K"};